import ApiService from '../ApiService';
import { DashboardSerializer } from 'services/serializers/v2';

class DashboardService extends ApiService {
  constructor(session) {
    super(session);

    this.url = '/v2/dashboard';
  }

  getNoApplicants(params) {
    return super.search(
      `${this.url}/shifts/no_applicants.json`,
      params,
      (response) => {
        return {
          per_page: response.per_page,
          total_pages: response.total_pages,
          total: response.total,
          current_page: response.current_page,
          shifts: response.shifts.map(
            DashboardSerializer.deserializeShiftWithNoApps
          ),
        };
      }
    );
  }

  getMarketplaceStats(zip = null) {
    const url = `${this.url}/marketplace_stats`;
    const mapFunc = (response) => ({
      hasEvents: response.has_events,
      atsOnPlatform: response.ats_on_platform,
      hoursPosted: response.hours_posted,
      jobsPosted: response.jobs_posted,
      atsWithin50Miles: response.ats_within_50_miles,
      avgTransactedRate: response.avg_transacted_rate,
    });

    if (zip) {
      return super.search(url, { zip }, mapFunc);
    }
    return super.get(url, mapFunc);
  }

  getShiftModifications(params) {
    return super.search(
      `${this.url}/job_modifications.json`,
      params,
      (response) => {
        return {
          per_page: response.per_page,
          total_pages: response.total_pages,
          total: response.total,
          current_page: response.current_page,
          modifications: response.job_modifications.map((modification) =>
            DashboardSerializer.deserializeJobModification({
              ...modification,
              athletic_trainers: response.athletic_trainers,
            })
          ),
        };
      }
    );
  }
}

export default DashboardService;
